import cn from 'clsx';
import { faAngleRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Category } from './types';

type Props = {
  categories: Category[];
  selectedId: string | null;
  onSelect: (categoryId: string | null) => void;
};

/**
 * Zinio's categories, down the left.
 *
 * Buttons rather than links, because picking one is a request for different covers and
 * not a different page. Hidden below `md`, where GridHeader's select takes over.
 *
 * No badges beside the names, unlike Magzter Gold's sidebar: Zinio's categories carry a
 * wide banner photograph rather than an icon, and headless_jshop drew none here for that
 * reason. A round crop of a landscape photo is worse than the text on its own.
 */
export default function CategorySidebar({ categories, selectedId, onSelect }: Props) {
  return (
    <nav aria-label="Magazine categories" className="hidden md:block md:col-span-5 lg:col-span-3">
      <div className="p-3 bg-slate-100 rounded text-center mb-3">
        <h2 className="text-xl font-semibold">Categories</h2>
      </div>

      <ul className="list-none p-0 m-0">
        {categories.map((category) => {
          const isActive = category.id === selectedId;

          return (
            <li key={category.id ?? 'all'}>
              <button
                type="button"
                aria-current={isActive ? 'true' : undefined}
                onClick={() => onSelect(category.id)}
                className={cn(
                  'group flex items-center justify-between font-semibold text-left w-full pl-3 pr-4 py-2 rounded mb-1',
                  isActive
                    ? 'text-white bg-zinio-purple-600'
                    : 'bg-white text-black hover:bg-zinio-purple-100 hover:text-zinio-purple-900 active:bg-zinio-purple-600 active:text-white'
                )}
              >
                <span>{category.name}</span>
                <FontAwesomeIcon
                  icon={faAngleRight}
                  size="lg"
                  className={cn(
                    'group-hover:text-zinio-purple-900',
                    isActive ? 'text-white' : 'text-zinio-purple-400'
                  )}
                />
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
